
export const SET_REQUEST_STATUS_CODE = 'app/error/SET_REQUEST_STATUS_CODE';